const o = {
  name: "ArrowUpDownSort",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4144 7.00015L8.00015 1.58594L2.58594 7.00015L4.00015 8.41436L7 5.41452V15.0001H9V5.41421L12.0002 8.41436L13.4144 7.00015Z" fill="currentColor"/>
<path d="M17 18.5861V9.00012H15V18.5858L12.0002 15.5859L10.5859 17.0002L16.0002 22.4144L21.4144 17.0002L20.0002 15.5859L17 18.5861Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowUpDownSort
};
